import React, { Fragment } from "react";
import { get } from "../../../containers/activite/map/map.utils";
import { HighlightedText, PlaceholderText } from "../Components/CustomSpan.component";

const InfosPdc = ({ pdc, request = {} }) => {
  const phone = pdc.phone;
  const numFax = pdc.num_fax;
  const centrales = pdc.centrales || [];
  return (
    <Fragment>
      <div className="p-w-1-2 p-pdc-detail-infos-text">
        <div className="p-pdc-detail-address">
          <HighlightedText request={request} field={"address"}>
            {pdc.address || <PlaceholderText text={"Adresse non renseignée"} />}
          </HighlightedText>
          <br />
          <HighlightedText request={request} field={"zip_code"}>
            {" "}
            {pdc.zip_code || <PlaceholderText text={"CP non renseigné"} />}{" "}
          </HighlightedText>{" "}
          <HighlightedText request={request} field={"city"}>
            {pdc.city || <PlaceholderText text={"Ville non renseignée"} />}
          </HighlightedText>
        </div>
        <br />
        <div className="p-pdc-detail-phone">
          <HighlightedText request={request} field={"phone"}>
            <b>Tel. :</b> {phone || <PlaceholderText />}
          </HighlightedText>
        </div>
        <div className="p-pdc-detail-phone">
          <HighlightedText request={request} field={"numFax"}>
            <b>Fax. :</b> {numFax || <PlaceholderText />}
          </HighlightedText>
        </div>
        <br />
        <div className="p-pdc-detail-centrales">
          {centrales.length === 0 && (
            <div>
              <b>Centrale nationale :</b> {<PlaceholderText />}
              <br />
              <b>Centre régionale :</b> {<PlaceholderText />}
            </div>
          )}
          {centrales.map((centrale, i) => {
            const nationale = get(["nationale", "nom"], centrale, null);
            const regionale = get(["regionale", "nom"], centrale, null);
            return (
              <div key={i}>
                <b>Centrale nationale :</b> {nationale || <PlaceholderText />}
                <br />
                <b>Centre régionale :</b> {regionale || <PlaceholderText />}
              </div>
            );
          })}
        </div>
        <b>Intégré / indépendant :</b> <PlaceholderText />
      </div>
    </Fragment>
  );
};

export default InfosPdc;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Info.detailpdc.js